import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-catalogo-obras-inversionistas-individual',
  templateUrl: './catalogo-obras-inversionistas-individual.component.html',
  styleUrls: ['./catalogo-obras-inversionistas-individual.component.scss']
})
export class CatalogoObrasInversionistasIndividualComponent implements OnInit {

  @Input() inversionista: any;
  @Input() canDelete: boolean = true;
  @Output() deleteInversionista: EventEmitter<any> = new EventEmitter;
  @Output() changeParticipacion: EventEmitter<string> = new EventEmitter;

  constructor() { }

  ngOnInit() {
  }
  delete() {
    this.deleteInversionista.emit();
  }
  change($event) {
   this.inversionista.participacion = $event;
   this.inversionista.inversionInicial = this.inversionista.inversionInicial.toString().replace(/\B(?=(\d{3})+(?!\d{3})+(?!\d))/g, ",");
   this.changeParticipacion.emit();
  }

  callback(){

  }

}



// WEBPACK FOOTER //
// ./src/app/components/catalogo-obras/catalogo-obras-inversionistas/catalogo-obras-inversionistas-individual/catalogo-obras-inversionistas-individual.component.ts